import {
  WarrntyItemAction,
  WarrntyItemActionTypes,
  WarrntyItemState,
} from "./types";

const initialState: WarrntyItemState = {
  warrantyId: "",
  claimId: "",
  options: {
    claimItemTypes: [],
    materialTypes: [],
    manufacturers: [],
    colors: [],
  },
  showSucessModal: false,
};

export const warrntyItemReducer = (
  state: WarrntyItemState = initialState,
  action: WarrntyItemActionTypes
): WarrntyItemState => {
  switch (action.type) {
    case WarrntyItemAction.SET_OPTIONS: {
      return {
        ...state,
        options: action?.payload || {},
      };
    }

    case WarrntyItemAction.SET_WARRNTYID_CLAIMID: {
      const { warranty_id, claim_id } = action?.payload || {};
      return {
        ...state,
        warrantyId: warranty_id || "",
        claimId: claim_id || "",
      };
    }

    case WarrntyItemAction.SHOW_SUCCES_MODAL: {
      return {
        ...state,
        showSucessModal: true,
      };
    }

    case WarrntyItemAction.HIDE_SUCCES_MODAL: {
      return {
        ...state,
        showSucessModal: false,
      };
    }

    case WarrntyItemAction.CLEAN_UP: {
      return {
        warrantyId: "",
        claimId: "",
        options: {
          claimItemTypes: [],
          materialTypes: [],
          manufacturers: [],
          colors: [],
        },
        showSucessModal: false,
      };
    }

    default:
      return state;
  }
};
